import { EAnswerType } from '@src/types';

export const REPLY_OPTIONS: { label: string; value: EAnswerType }[] = [
  { label: 'Reply privately', value: EAnswerType.PRIVATE },
  { label: 'Reply in public', value: EAnswerType.PUBLIC },
  { label: 'Live answering', value: EAnswerType.LIVE },
];
